import live from "./../styles/live.module.css"
import cx from "classnames"

export default function Live() {
    return(
        <>
            <div className={ live.container }>
                <img className={ live.container_background } src="/images/live/tramado.svg" alt="Tramado"/>
                <div className={ live.content }>
                    <div className={ live.content_vid_container }>
                        <div className={ live.content_vid }><iframe width="560" height="315" src="https://www.youtube.com/embed/MVji6jHDBus" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>
                        <div className={ live.disclaimer}>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
                    </div>
                    <div className={ live.logos }>
                        <img className={ live.logos_gam } src="/images/live/logo.svg" alt="Logo gam"/>
                        <div className={ live.logos_llenosdevida}>¡SOMOS LLENOS DE VIDA!</div>
                        <img className={ live.logos_triatlon } src="/images/live/logo.svg" alt="Logo triatlón"/>
                    </div>
                </div>
            </div>
        </>
    )
}